export default {
  namespaced: true,
  state     : {
    modals: [
      {
        type  : 'slider_modal',
        active: false,
      },
      {
        type  : 'avatar_modal',
        active: false,
      },

    ],

  },
  getters: {
    modals      : ({modals}) => modals,
    slider_modal: ({modals}) => modals.find((modal)=> modal.type == 'slider_modal').active,
    avatar_modal: ({modals}) => modals.find((modal)=> modal.type == 'avatar_modal').active,
  },
  mutations: {
    CLOSE_MODAL(state, type) {
      let modal = state.modals.find((modal)=> modal.type === type);
      modal.active = false;
    },
    OPEN_MODAL(state, type) {
      let modal = state.modals.find((modal)=> modal.type === type);
      if (!modal.active) {
        modal.active = true;
      }
    },
  },
};

